const KEY = "vrv_source";
const SEARCH = /(^|\.)(google|bing|yahoo|duckduckgo|yandex|baidu|ecosia|search\.brave)\./;
const SOCIAL = /(facebook|fb\.|instagram|^t\.co$|twitter|x\.com|linkedin|lnkd|pinterest|reddit|youtube|whatsapp|wa\.me|threads|telegram|snapchat|quora)/;

const save = (s) => localStorage.setItem(KEY, JSON.stringify({ ...s, at: new Date().toISOString() }));

export function captureSource() {
  try {
    const u = new URL(window.location.href);
    const p = u.searchParams;
    const host = u.hostname.replace(/^www\./, "");
    const ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : "";
    const src = p.get("utm_source") || "";
    const m = (p.get("utm_medium") || "").toLowerCase();
    const gclid = p.get("gclid") || p.get("gbraid") || p.get("wbraid");
    const fbclid = p.get("fbclid");
    if (!src && !m && !p.get("utm_campaign") && !gclid && !fbclid && (!ref || ref === host)) {
      if (!localStorage.getItem(KEY)) save({ channel: "Direct", source: "(direct)" });
      return;
    }
    let channel;
    if (gclid || /^(cpc|ppc|paidsearch|paid_search|sem)$/.test(m)) channel = SOCIAL.test(src) ? "Paid social" : "Paid search";
    else if (/paid/.test(m)) channel = "Paid social";
    else if (/email|newsletter/.test(m)) channel = "Email";
    else if (/social/.test(m) || SOCIAL.test(src) || fbclid || SOCIAL.test(ref)) channel = "Social media";
    else if (SEARCH.test(ref) || /organic/.test(m)) channel = "Organic search";
    else if (src) channel = "Campaign";
    else channel = "Referral";
    save({
      channel, source: src || ref || (gclid ? "google" : fbclid ? "facebook" : ""), medium: m, campaign: p.get("utm_campaign") || "",
      referrer: document.referrer.slice(0, 300), landing: (u.pathname + u.search).slice(0, 300),
    });
  } catch {
    /* storage unavailable */
  }
}

export function getSource() {
  try {
    const { at, ...s } = JSON.parse(localStorage.getItem(KEY) || "null") || {};
    return s.channel ? s : null;
  } catch {
    return null;
  }
}
